var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-d-flex p-flex-column p-jc-center p-ai-center h-full",style:({
    'background-image': 'url(' + _vm.backgroundImage + ')',
     position: 'relative'
  })},[_c('h1',[_vm._v(_vm._s(_vm.$t('pages.404.title')))]),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t('pages.404.link'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }